/* ── Channel-aware analytics mock data ── */

const CHANNEL_FUNNEL = {
  linkedin:  { visitors: '5.2K', mqls: 18, sqls: 8, pipeline: 52000 },
  meta:      { visitors: '4.8K', mqls: 3, sqls: 1, pipeline: 8000 },
  blog:      { visitors: '4.2K', mqls: 18, sqls: 7, pipeline: 48000 },
  email:     { visitors: '—', mqls: 8, sqls: 4, pipeline: 32000 },
  facebook:  { visitors: '1.6K', mqls: 4, sqls: 1, pipeline: 6000 },
  tiktok:    { visitors: '3.8K', mqls: 2, sqls: 0, pipeline: 0 },
};

const CHANNEL_WOW = {
  linkedin:  { thisWeek: { mqls: 18, sqls: 8, pipeline: 52000, spend: 1200, cpl: 86 }, lastWeek: { mqls: 15, sqls: 6, pipeline: 44000, spend: 1100, cpl: 92 } },
  meta:      { thisWeek: { mqls: 3, sqls: 1, pipeline: 8000, spend: 2100, cpl: 175 }, lastWeek: { mqls: 5, sqls: 2, pipeline: 14000, spend: 1800, cpl: 160 } },
  blog:      { thisWeek: { mqls: 18, sqls: 7, pipeline: 48000, spend: 800, cpl: 44 }, lastWeek: { mqls: 16, sqls: 6, pipeline: 42000, spend: 750, cpl: 47 } },
  email:     { thisWeek: { mqls: 8, sqls: 4, pipeline: 32000, spend: 150, cpl: 19 }, lastWeek: { mqls: 7, sqls: 3, pipeline: 28000, spend: 140, cpl: 20 } },
  facebook:  { thisWeek: { mqls: 4, sqls: 1, pipeline: 6000, spend: 600, cpl: 150 }, lastWeek: { mqls: 4, sqls: 1, pipeline: 5000, spend: 550, cpl: 138 } },
  tiktok:    { thisWeek: { mqls: 2, sqls: 0, pipeline: 0, spend: 400, cpl: 200 }, lastWeek: { mqls: 1, sqls: 0, pipeline: 0, spend: 460, cpl: 460 } },
};

const CHANNEL_TRENDS = {
  linkedin:  [
    { label: 'MQLs', value: '18', data: [10, 12, 14, 16, 18], trend: '+22%', trendUp: true },
    { label: 'Cost Per Lead', value: '$86', data: [105, 98, 94, 90, 86], trend: '-10%', trendUp: true },
    { label: 'Impressions', value: '18.6K', data: [11000, 13000, 15200, 16800, 18600], trend: '+22%', trendUp: true },
    { label: 'Engagement', value: '4.8%', data: [3.8, 4.0, 4.2, 4.5, 4.8], trend: '+12%', trendUp: true },
    { label: 'MQL to SQL', value: '44%', data: [38, 40, 41, 42, 44], trend: '+8%', trendUp: true },
    { label: 'Pipeline', value: '$52K', data: [32, 38, 42, 46, 52], trend: '+18%', trendUp: true },
  ],
  meta: [
    { label: 'MQLs', value: '3', data: [6, 5, 4, 4, 3], trend: '-40%', trendUp: false, alert: true },
    { label: 'Cost Per Lead', value: '$175', data: [140, 148, 158, 166, 175], trend: '+15%', trendUp: false, alert: true },
    { label: 'Impressions', value: '28.4K', data: [22000, 24000, 25600, 27000, 28400], trend: '+12%', trendUp: true },
    { label: 'Engagement', value: '1.9%', data: [2.4, 2.2, 2.1, 2.0, 1.9], trend: '-18%', trendUp: false, alert: true },
    { label: 'MQL to SQL', value: '33%', data: [36, 35, 34, 34, 33], trend: '-6%', trendUp: false },
    { label: 'Pipeline', value: '$8K', data: [14, 12, 10, 9, 8], trend: '-38%', trendUp: false, alert: true },
  ],
  blog: [
    { label: 'MQLs', value: '18', data: [12, 14, 15, 16, 18], trend: '+14%', trendUp: true },
    { label: 'Cost Per Lead', value: '$44', data: [52, 50, 48, 46, 44], trend: '-12%', trendUp: true },
    { label: 'Traffic', value: '4.2K', data: [2800, 3100, 3400, 3700, 4200], trend: '+14%', trendUp: true },
    { label: 'Avg. Read Time', value: '4.2m', data: [3.5, 3.6, 3.8, 4.0, 4.2], trend: '+10%', trendUp: true },
    { label: 'MQL to SQL', value: '39%', data: [34, 35, 36, 37, 39], trend: '+8%', trendUp: true },
    { label: 'Pipeline', value: '$48K', data: [32, 36, 40, 44, 48], trend: '+16%', trendUp: true },
  ],
  email: [
    { label: 'MQLs', value: '8', data: [6, 6, 7, 7, 8], trend: '+14%', trendUp: true },
    { label: 'Cost Per Lead', value: '$19', data: [24, 22, 21, 20, 19], trend: '-15%', trendUp: true },
    { label: 'Open Rate', value: '34%', data: [30, 31, 32, 33, 34], trend: '+6%', trendUp: true },
    { label: 'Click Rate', value: '8.2%', data: [6.5, 7.0, 7.4, 7.8, 8.2], trend: '+12%', trendUp: true },
    { label: 'MQL to SQL', value: '50%', data: [42, 44, 46, 48, 50], trend: '+10%', trendUp: true },
    { label: 'Pipeline', value: '$32K', data: [22, 24, 27, 30, 32], trend: '+18%', trendUp: true },
  ],
  facebook: [
    { label: 'MQLs', value: '4', data: [5, 4, 4, 4, 4], trend: '-2%', trendUp: false },
    { label: 'Cost Per Lead', value: '$150', data: [130, 135, 140, 145, 150], trend: '+9%', trendUp: false },
    { label: 'Impressions', value: '9.2K', data: [8800, 8900, 9000, 9100, 9200], trend: '+2%', trendUp: true },
    { label: 'Engagement', value: '1.8%', data: [2.0, 1.9, 1.9, 1.8, 1.8], trend: '-5%', trendUp: false },
    { label: 'MQL to SQL', value: '25%', data: [28, 27, 26, 26, 25], trend: '-8%', trendUp: false },
    { label: 'Pipeline', value: '$6K', data: [8, 7, 7, 6, 6], trend: '-20%', trendUp: false },
  ],
  tiktok: [
    { label: 'MQLs', value: '2', data: [0, 0, 1, 1, 2], trend: '+210%', trendUp: true },
    { label: 'Cost Per Lead', value: '$200', data: [0, 0, 460, 320, 200], trend: '-38%', trendUp: true },
    { label: 'Impressions', value: '22.1K', data: [4200, 8600, 14000, 18400, 22100], trend: '+210%', trendUp: true },
    { label: 'Engagement', value: '8.4%', data: [5.2, 6.1, 7.0, 7.8, 8.4], trend: '+32%', trendUp: true },
    { label: 'Followers', value: '1.2K', data: [200, 400, 680, 920, 1200], trend: '+180%', trendUp: true },
    { label: 'Pipeline', value: '$0', data: [0, 0, 0, 0, 0], trend: '—', trendUp: false },
  ],
};

/* ── Date-range variants ── */
const WEEKLY_DATA = {
  funnel: [
    { stage: 'Visitors', value: '12.4K' },
    { stage: 'MQLs', value: '47', conversion: '0.38%' },
    { stage: 'SQLs', value: '18', conversion: '38.3%' },
    { stage: 'Pipeline', value: '$127K', conversion: '—' },
  ],
  trends: [
    { label: 'MQLs', value: '47', data: [28, 32, 35, 42, 47], trend: '+12%', trendUp: true },
    { label: 'Cost Per Lead', value: '$118', data: [142, 135, 128, 122, 118], trend: '-8%', trendUp: true },
    { label: 'Blog Traffic', value: '4.2K', data: [2800, 3100, 3400, 3700, 4200], trend: '+14%', trendUp: true },
    { label: 'Social Reach', value: '18.6K', data: [11000, 12800, 14200, 16100, 18600], trend: '+22%', trendUp: true },
    { label: 'MQL to SQL', value: '18%', data: [24, 22, 21, 20, 18], trend: '-6%', trendUp: false, alert: true },
    { label: 'Pipeline Value', value: '$127K', data: [95, 102, 108, 118, 127], trend: '+5%', trendUp: true },
  ],
  weeklyComparison: {
    thisWeek: { mqls: 47, sqls: 18, pipeline: 127000, spend: 5250, cpl: 118 },
    lastWeek: { mqls: 42, sqls: 16, pipeline: 118000, spend: 4800, cpl: 122 },
  },
  label: 'Last 4 weeks',
};

const MONTHLY_DATA = {
  funnel: [
    { stage: 'Visitors', value: '48.6K' },
    { stage: 'MQLs', value: '186', conversion: '0.38%' },
    { stage: 'SQLs', value: '68', conversion: '36.6%' },
    { stage: 'Pipeline', value: '$490K', conversion: '—' },
  ],
  trends: [
    { label: 'MQLs', value: '186', data: [142, 155, 168, 176, 186], trend: '+18%', trendUp: true },
    { label: 'Cost Per Lead', value: '$112', data: [148, 138, 128, 120, 112], trend: '-14%', trendUp: true },
    { label: 'Blog Traffic', value: '16.4K', data: [10200, 12000, 13600, 14800, 16400], trend: '+24%', trendUp: true },
    { label: 'Social Reach', value: '72K', data: [42000, 50000, 58000, 64000, 72000], trend: '+28%', trendUp: true },
    { label: 'MQL to SQL', value: '20%', data: [26, 24, 22, 21, 20], trend: '-4%', trendUp: false, alert: true },
    { label: 'Pipeline Value', value: '$490K', data: [340, 380, 420, 460, 490], trend: '+12%', trendUp: true },
  ],
  weeklyComparison: {
    thisWeek: { mqls: 186, sqls: 68, pipeline: 490000, spend: 21000, cpl: 112 },
    lastWeek: { mqls: 158, sqls: 54, pipeline: 410000, spend: 19200, cpl: 121 },
  },
  label: 'Last 3 months',
};

export const DATE_RANGES = [
  { id: 'weekly', label: 'Weekly' },
  { id: 'monthly', label: 'Monthly' },
];

export const ANALYTICS_DATA = {
  ...WEEKLY_DATA,
  channelROI: [
    { id: 'linkedin', channel: 'LinkedIn Organic', spend: 0, leads: 18, cpl: '$0', roi: '—', impressions: '18.6K', engagement: '4.8%', trend: '+22%' },
    { id: 'linkedin-ads', channel: 'LinkedIn Ads', spend: 1200, leads: 14, cpl: '$86', roi: '4.2x', impressions: '24.1K', engagement: '3.4%', trend: '+8%' },
    { id: 'meta', channel: 'Meta Ads', spend: 2100, leads: 3, cpl: '$175', roi: '0.8x', impressions: '28.4K', engagement: '1.9%', trend: '-15%', alert: true },
    { id: 'blog', channel: 'Blog / SEO', spend: 800, leads: 18, cpl: '$44', roi: '8.6x', impressions: '4.2K', engagement: '—', trend: '+14%' },
    { id: 'email', channel: 'Email Nurture', spend: 150, leads: 8, cpl: '$19', roi: '12.1x', impressions: '—', engagement: '34%', trend: '+3%' },
    { id: 'facebook', channel: 'Facebook', spend: 600, leads: 4, cpl: '$150', roi: '1.1x', impressions: '9.2K', engagement: '1.8%', trend: '-2%' },
    { id: 'tiktok', channel: 'TikTok', spend: 400, leads: 2, cpl: '$200', roi: '0.5x', impressions: '22.1K', engagement: '8.4%', trend: '+210%' },
  ],
  insights: [
    { id: 'ai1', agent: 'dora', text: 'LinkedIn organic is your highest-ROI channel \u2014 18 leads at $0 spend. Recommend increasing posting cadence to capitalize on momentum.', type: 'recommendation', time: '2 hrs ago' },
    { id: 'ai2', agent: 'dora', text: 'Meta Ads ROI is below 1.0x ($175 CPL vs $86 on LinkedIn Ads). Data supports reallocating remaining Meta budget to LinkedIn.', type: 'alert', time: '3 hrs ago' },
    { id: 'ai3', agent: 'dora', text: 'MQL\u2192SQL conversion dropped from 24% to 18% over 4 weeks. Root cause: broader top-of-funnel targeting is attracting less qualified leads.', type: 'alert', time: '5 hrs ago' },
    { id: 'ai4', agent: 'dora', text: 'Email nurture has the lowest CPL ($19) and highest ROI (12.1x). Consider expanding the sequence from 5 to 7 emails with case study content.', type: 'recommendation', time: 'Yesterday' },
    { id: 'ai5', agent: 'dora', text: 'TikTok showing early promise \u2014 8.4% engagement rate is the highest across channels. Low lead count (2) expected at this stage; recommend continued investment.', type: 'insight', time: 'Yesterday' },
  ],
};

export const ANALYTICS_DATA_BY_RANGE = {
  weekly: WEEKLY_DATA,
  monthly: MONTHLY_DATA,
};

export const CHANNEL_ANALYTICS = {
  funnel: CHANNEL_FUNNEL,
  wow: CHANNEL_WOW,
  trends: CHANNEL_TRENDS,
};

export const ANALYTICS_CHAT_RESPONSES = {
  general: {
    text: "Here's your marketing analytics summary.\n\nOverall performance is trending positively \u2014 MQLs up 12%, pipeline up 5%, and CPL down 8% week-over-week. Your top-performing channels are Email Nurture (12.1x ROI) and Blog/SEO (8.6x ROI).\n\nTwo areas need attention: Meta Ads is underperforming at 0.8x ROI, and MQL\u2192SQL conversion has been declining for 4 weeks. I've prepared detailed recommendations on both. Want me to elaborate?",
  },
  channelDeep: (channelName) => ({
    text: `Here's a deep dive on ${channelName}.\n\nI've analyzed the last 4 weeks of data for this channel. Let me walk you through the key metrics, trends, and my recommendations.`,
  }),
};
